/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-11-28 16:55:06
 * @modify date 2023-11-28 16:55:06
 * @desc [description]
 */

import { View } from "react-native";
import SmtpMgmtView from "./SmtpMgmtView";
import { useEffect, useState } from "react";
import { SmtpMgmtData, initSmtpMgmtData, smtpMgmtUpdateModalContents } from "./SmtpMgmtData";
import { requests } from "common/RestAPI";
import { PLATFORM_URL } from "value/Url";
import { useTranslation } from "react-i18next";



export interface SmtpMgmtContainerProps {
  setLoading: Function;
  showSlideModalCb?: Function;
  showPopupModalCb: Function;
}


export default function SmtpMgmtContainer(props:SmtpMgmtContainerProps) {
  const {t} = useTranslation();
  const [refreshYn, setRefreshYn] = useState(false);
  const [infoText, setInfoText] = useState('');
  const [infoError, setInfoError] = useState(false);
  const [receiveMail, setReceiveMail] = useState('');
  const [receiveContents, setReceiveContents] = useState('');
  const [queryData, setQueryData] = useState<SmtpMgmtData>(initSmtpMgmtData);

  useEffect(() => {
    requestSmtpData();
  }, [])


  useEffect(() => {
    if (refreshYn) {
      requestSmtpData();
    }
  }, [refreshYn])


  function AlertFunction(text:string, error=false) {
    setInfoText(text);
    setInfoError(error);
  }


  function requestSmtpData() {
    props.setLoading(true);
    requests.get(PLATFORM_URL.SMTP)
    .then((response) => {
      if (response.status === 200 && response.data) {
        setQueryData(response.data);
      }
      props.setLoading(false);
      setRefreshYn(false);
    })
    .catch((_) => {
      AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
      props.setLoading(false);
      setRefreshYn(false);
    });
  }



  function updateSmtpResult(data) {
    if(data.successYn) {
        AlertFunction(t("MESSAGE_ACCOUNT_UPDATE_SUCCESS_MESSAGE"));
        setRefreshYn(true);
    }
  }


  function clickUpdateBtnCb() {
    if(props.showSlideModalCb) {
      props.showSlideModalCb({...smtpMgmtUpdateModalContents, openYn: true, resultCb: updateSmtpResult, args: queryData});
    }
  }


  function sendTestMailCb() {
    const body = {
      system_smtp: {
        email: receiveMail,
        test_message: receiveContents
      }
    }

    requests.post(PLATFORM_URL.SMTP + '/test', body)
    .then((_) => {
      AlertFunction(t("MENU_APPLICATION_SMTP_SUCCESS_SEND_TEST_MAIL"));
    })
    .catch((_) => {
      AlertFunction(t("MENU_APPLICATION_SMTP_FAILED_SEND_TEST_MAIL"), true);
    })
  }



  return (
    <SmtpMgmtView
      infoText={infoText}
      infoError={infoError}
      clickUpdateBtnCb={clickUpdateBtnCb}
      clickSendMailBtnCb={sendTestMailCb}
      receiveMail={receiveMail}
      setReceiveMail={setReceiveMail}
      receiveContents={receiveContents}
      setReceiveContents={setReceiveContents}
      queryData={queryData}/>
  )
}